export const chunkArray = <T>(arr: T[], chunk_size: number): T[][] => {
  const results: T[][] = [];

  while (arr.length) {
    results.push(arr.splice(0, chunk_size));
  }

  return results;
};
